import React, { useState, useEffect } from 'react';
import { Widget, Table, ColumnProps, MasterDetailForm, Row, Col } from '@digital/ui';
import { Icon, Collapse } from 'antd';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { ProjetoControleNaoPrevisto, getProjetosNaoPrevistoControleNaoPrevisto } from '@app/api/naoPrevistos/controle';
import StatusCircle from '@app/components/statusCircle';

interface Props {
    ano: number;
}

const AbaNaoPrevisto = ({ano}: Props) => {
    const { Panel } = Collapse;
    const [dataSource, setDataSource] = useState<ProjetoControleNaoPrevisto[]>();
    const [valorTotalOrcado, setValorTotalOrcado] = useState('');
    const [valorTotalContratado, setValorTotalContratado] = useState('');
    const [valorTotalExecutado, setValorTotalExecutado] = useState('');
    const [valorTotalRequisitado, setValorTotalRequisitado] = useState('');
    const [valorTotalCompromissado, setValorTotalCompromissado] = useState('');
    const [valorTotalAContratar, setValorTotalAContratar] = useState('');
    const [valorTotalForecast, setValorTotalForecast] = useState('');
    const [valorTotalSaldo, setValorTotalSaldo] = useState('');

    const generateRowKey = (data: ProjetoControleNaoPrevisto, keyParent?: string) => {
        data.key = keyParent ? `${keyParent}-${data.codigoProjeto}` : data.codigoProjeto;

        if (data.children && data.children.length)
            data.children.forEach(child => generateRowKey(child, data.key));

        return data;
    };

    useEffect(() => {
        if (ano) {
            getProjetosNaoPrevistoControleNaoPrevisto(ano).then((data) => {
                setDataSource(data?.projetos?.map(d => generateRowKey(d)));
                setValorTotalOrcado(data?.valorTotalOrcado ?? '');
                setValorTotalContratado(data?.valorTotalContratado ?? '');
                setValorTotalExecutado(data?.valorTotalExecutado ?? '');
                setValorTotalRequisitado(data?.valorTotalRequisitado ?? '');
                setValorTotalCompromissado(data?.valorTotalCompromissado ?? '');
                setValorTotalAContratar(data?.valorTotalAContratar ?? '');
                setValorTotalForecast(data?.valorTotalForecast ?? '');
                setValorTotalSaldo(data?.valorTotalSaldo ?? '');
            });
        }
    }, [ano]);

    const columns: ColumnProps<ProjetoControleNaoPrevisto>[] = [
        {
            dataIndex: 'dropDown'
        },
        {
            title: 'Código',
            dataIndex: 'codigoProjeto',
            align: 'left',
            ...mountFormFilterDropDown('codigoProjeto', 'Pesquisar'),
            render: (_text, row) => {    
                return (
                    <div style={{ textAlign: 'left' }}>
                        {row.codigoProjeto}
                    </div>
                );
            }
        },
        {
            title: 'Nome',
            dataIndex: 'nomeProjeto',
            align: 'left',
            ...mountFormFilterDropDown('nomeProjeto', 'Pesquisar')
        },
        {
            title: () => <>{valorTotalOrcado}</>,
            children: [
                {
                    title: 'Orçado',
                    dataIndex: 'valorOrcado',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalContratado}</>,
            children: [
                {
                    title: 'Contratado',
                    dataIndex: 'valorContratado',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalExecutado}</>,
            children: [
                {
                    title: 'Executado',
                    dataIndex: 'valorExecutado',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalRequisitado}</>,
            children: [
                {
                    title: 'Requisitado',
                    dataIndex: 'valorRequisitado',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalCompromissado}</>,
            children: [
                {
                    title: 'Compromissado',
                    dataIndex: 'valorCompromissado',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalAContratar}</>,
            children: [
                {
                    title: 'A Contratar',
                    dataIndex: 'valorAContratar',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalForecast}</>,
            children: [
                {
                    title: 'Forecast',
                    dataIndex: 'valorForecast',
                    align: 'center',
                }
            ]
        },
        {
            title: () => <>{valorTotalSaldo}</>,
            children: [
                {
                    title: 'Saldo',
                    dataIndex: 'valorSaldo',
                    align: 'center',
                }
            ]
        },
        {
            title: 'Doação',
            dataIndex: 'valorDoacao',
            align: 'center',
        },
        {
            title: 'Total de Doações\n Compromissadas',
            dataIndex: 'valorTotalDoacoes',
            align: 'center',
            width: 160
        },
        {
            title: 'Situação',
            dataIndex: 'situacaoCor',
            align: 'center',
            render: (_text, row, _index) => {
                return <StatusCircle noPrazo={ row.situacaoCor && row.situacaoCor.toLowerCase() === "green"} valorLabel={''} />
            },
        },
    ];

    return(
        <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type='arrows-right_4' />}>
            <Panel key='1' header='Não Previsto' style={{ border: 0 }}>
                <MasterDetailForm>
                    <Widget>
                        <Row>
                            <Col span={12}>
                                <Table
                                    className='ColorTableLevel0'
                                    rowKey={(record, index) => index.toString()}
                                    key='key'
                                    columns={columns}
                                    dataSource={dataSource}
                                    pagination={{ pageSize: 10 }}
                                />
                            </Col>
                        </Row>
                    </Widget>
                </MasterDetailForm>
            </Panel>
        </Collapse>
    );
};

export default AbaNaoPrevisto;